/**
 * PAPPO — Groups Service
 * Grupos DE UTILIZADOR (/api/groups): criados pelo usuário a partir dos seus
 * contatos. O criador é admin (renomeia/foto/adiciona/remove). Qualquer membro
 * pode SAIR. Distinto do grupo "Família" (/api/family), que é fechado.
 */

import { apiPost, apiPut, apiDelete } from './api';
import type { Conversation } from '../types/message';

/** Cria um grupo com um nome e uma lista de contatos (ids). */
export async function createGroup(name: string, memberIds: number[]) {
  return apiPost<{ group: Conversation }>('/groups', {
    name,
    member_ids: memberIds,
  });
}

/** Renomeia e/ou troca a foto do grupo (só admin). avatar_url = /uploads/<uuid>. */
export async function updateGroup(
  groupId: number,
  patch: { name?: string; avatar_url?: string }
) {
  return apiPut<{ group: Conversation }>(`/groups/${groupId}`, patch);
}

/** Admin adiciona um contato ao grupo. */
export async function addGroupMember(groupId: number, userId: number) {
  return apiPost<{ group: Conversation }>(`/groups/${groupId}/members`, {
    user_id: userId,
  });
}

/** Admin remove um membro do grupo. */
export async function removeGroupMember(groupId: number, userId: number) {
  return apiDelete<{ removed_id: number }>(
    `/groups/${groupId}/members/${userId}`
  );
}

/** O utilizador atual sai do grupo (bloqueado no grupo da família). */
export async function leaveGroup(groupId: number) {
  return apiPost<{ remaining_ids: number[] }>(`/groups/${groupId}/leave`);
}
